const MODAL_TYPES = {
    EDIT: 'EDIT',
    ADD: 'ADD',
    DELETE: 'DELETE'
};

const MODAL_SIZES = {
    SMALL: 400,
    MEDIUM: 600,
    LARGE: 900
};

export { MODAL_TYPES, MODAL_SIZES };

export const SWITCH_TYPE_EVCC = 'Evcc';
export const SWITCH_TYPE_MODBUS = 'Modbus';
export const SWITCH_TYPE_SHELLY = 'Shelly';
export const SWITCH_TYPE_OCPP_GATEWAY = 'OcppGateway';
export const RELAY_TYPE_MODBUS = 'ModbusRegister';
